// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__Cv1H7","primary":"Button_primary__Ch3ye","secondary":"Button_secondary__Ocz0V"};